import { userProfileConstants } from '../../_constants';
import swal from 'sweetalert2';



const initialState = { changePasswordLoading: true, data: '', error: false };

export function changePasswordReducer(state = initialState, action) {

    switch (action.type) {
        case userProfileConstants.REQUEST_CHANGE_PASSWORD:
            return {
                changePasswordLoading: true,
                data: '',
                error: false
            };
        case userProfileConstants.RECEIVE_CHANGE_PASSWORD:
            swal({
                text: 'Successfully Changed Password',
                type: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            })
                .then((result) => {
                    localStorage.clear();
                    window.location.reload();
                })


            return {
                changePasswordLoading: false,
                data: action.changePassword,
                error: false
            };
        case userProfileConstants.CHANGE_PASSWORD_ERROR:

            swal({
                text: action.error.response.data.message,
                type: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            })
            return {
                changePasswordLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/userProfile/changePassword.reducer.js